
import Vue from 'vue'
import Component from 'vue-class-component'
import { Toast } from 'vant'
import { Mixins } from 'vue-property-decorator'
import { getUrlArg } from '@space/utils'
import MechanismHeader from '@/components/MechanismHeader.vue'
import jzMechanismContent from './jzMechanismContent.vue'
import helpMechanismContent from './helpMechanismContent.vue'
@Component({
  components: { MechanismHeader, jzMechanismContent, helpMechanismContent },
})
export default class IndexView extends Vue {
  active = 2
  userName = ''
  userPhone = ''
  companyName = ''
  catalogueType = 1
  showType = {
    jz: true,
    help: false,
  }
  jzCatalogueList = [
    {
      id: 17975,
      label: '一、准备工作',
      level: 'one',
      isActive: false,
    },
    {
      id: 28366,
      label: '二、选择开户类型',
      level: 'one',
      isActive: false,
    },
    {
      id: 5312,
      label: '三、机构预约开户',
      level: 'one',
      isActive: false,
    },
    {
      id: 5113,
      label: '1.手机验证',
      level: 'two',
      isActive: false,
    },
    {
      id: 29589,
      label: '2.身份验证',
      level: 'two',
      isActive: false,
    },
    {
      id: 1285,
      label: '3.信息录入',
      level: 'two',
      isActive: false,
    },
    {
      id: 5144,
      label: '4.开户申请',
      level: 'two',
      isActive: false,
    },
    {
      id: 28744,
      label: '5.申请结果展示',
      level: 'two',
      isActive: false,
    },
    {
      id: 30495,
      label: '四、产品预约开户',
      level: 'one',
      isActive: false,
    },
    {
      id: 18069,
      label: '1.手机验证',
      level: 'two',
      isActive: false,
    },
    {
      id: 1904,
      label: '2.身份验证',
      level: 'two',
      isActive: false,
    },
    {
      id: 19072,
      label: '3.信息录入',
      level: 'two',
      isActive: false,
    },
    {
      id: 19164,
      label: '4.开户申请',
      level: 'two',
      isActive: false,
    },
    {
      id: 23736,
      label: '5.申请结果展示',
      level: 'two',
      isActive: false,
    },
    {
      id: 20296,
      label: '五、预约进度开户查询',
      level: 'one',
      isActive: false,
    },
    {
      id: 22513,
      label: '1.手机验证',
      level: 'two',
      isActive: false,
    },
    {
      id: 27349,
      label: '2.进度查询展示',
      level: 'two',
      isActive: false,
    },
  ]
  helpCatalogueList = [
    // {
    //   id: 2,
    //   label: '一、什么是华源机构通？',
    //   level: 'one',
    //   isActive: false,
    // },
    // {
    //   id: 3,
    //   label: '二、为什么使用华源机构通？',
    //   level: 'one',
    //   isActive: false,
    // },
    // {
    //   id: 4,
    //   label: '四、机构理财平台如何使用？',
    //   level: 'one',
    //   isActive: false,
    // },
    {
      id: 5,
      label: '一、登录',
      level: 'one',
      isActive: false,
    },
    {
      id: 6,
      label: '二、个人中心',
      level: 'one',
      isActive: false,
    },
    {
      id: 7,
      label: '三、账户管理',
      level: 'one',
      isActive: false,
    },
    {
      id: 71,
      label: '1.账户授权',
      level: 'two',
      isActive: false,
    },
    {
      id: 72,
      label: '2.授信管理',
      level: 'two',
      isActive: false,
    },
    {
      id: 73,
      label: '3.黑名单管理',
      level: 'two',
      isActive: false,
    },
    {
      id: 8,
      label: '四、登录账号管理',
      level: 'one',
      isActive: false,
    },
    {
      id: 9,
      label: '五、工作台',
      level: 'one',
      isActive: false,
    },
    {
      id: 10,
      label: '六、我的账户',
      level: 'one',
      isActive: false,
    },
    {
      id: 101,
      label: '1.机构总览',
      level: 'two',
      isActive: false,
    },
    {
      id: 102,
      label: '2.我的持仓',
      level: 'two',
      isActive: false,
    },
    {
      id: 103,
      label: '3.我的自选',
      level: 'two',
      isActive: false,
    },
    // {
    //   id: 104,
    //   label: '4.预购清单',
    //   level: 'two',
    //   isActive: false,
    // },
    {
      id: 11,
      label: '七、交易管理',
      level: 'one',
      isActive: false,
    },
    {
      id: 111,
      label: '1.交易下单',
      level: 'two',
      isActive: false,
    },
    {
      id: 112,
      label: '2.交易复核',
      level: 'two',
      isActive: false,
    },
    {
      id: 113,
      label: '3.交易撤单',
      level: 'two',
      isActive: false,
    },
    {
      id: 114,
      label: '4.交易查询',
      level: 'two',
      isActive: false,
    },
    {
      id: 12,
      label: '八、基金管理',
      level: 'one',
      isActive: false,
    },
    {
      id: 13,
      label: '九、查询与分析',
      level: 'one',
      isActive: false,
    },
    {
      id: 131,
      label: '1.交易查询',
      level: 'two',
      isActive: false,
    },
    {
      id: 132,
      label: '2.资金流水',
      level: 'two',
      isActive: false,
    },
    {
      id: 133,
      label: '3.账单管理',
      level: 'two',
      isActive: false,
    },
    {
      id: 134,
      label: '4.对账单查询',
      level: 'two',
      isActive: false,
    },
    // {
    //   id: 14,
    //   label: '五、华源机构通常见问题',
    //   level: 'one',
    //   isActive: false,
    // },
  ]
  introduceList = [
    {
      imageName: 'online',
      title: '业务线上化',
      describe:
        '线上化交易平台，支持上架多种基金产品，供机构投资者多方位选型产品，为机构投资者提供投研服务，从投前、投中、投后全面赋能机构投资者。',
    },
    {
      imageName: 'systemPlatform',
      title: '系统平台化',
      describe: '与公司现有多套系统进行交互对接，实现全流程电子化的理财产品交易。',
    },
    {
      imageName: 'diversification',
      title: '功能多样化',
      describe:
        '提供便捷的线上+线下结合的方式开户。提升交易效率，解决单笔交易效率低、单笔限额等问题。投研方面提供专业化的资源和工具帮助，便于快速进行投资标的筛选和确定。',
    },
  ]
  transactList = [
    {
      title: '01. 上传信息 免费开户',
      tag: '开户帮助',
      stepIcon: 'stepOne',
    },
    {
      title: '02. 登录交易端交易',
      tag: '交易指南',
      stepIcon: 'stepTwo',
    },
    {
      title: '03. 购买基金  走上机构理财之路',
      stepIcon: 'stepThree',
    },
  ]
  created() {
    window.scroll(0, 0)
    if (getUrlArg('catalogueType')) {
      this.catalogueType = Number(getUrlArg('catalogueType'))
      if (this.catalogueType === 2) {
        this.showType.jz = false
        this.showType.help = true
      }
    }
  }
  //操作指引切换
  switchCatalogue(type: number) {
    this.catalogueType = type
    if (type === 1) {
      this.showType.jz = !this.showType.jz
    } else {
      this.showType.help = !this.showType.help
    }
    this.$forceUpdate()
  }
  //点击
  clickPath(id: number, type: string) {
    if (type === 'jzCatalogueList') {
      if (this.catalogueType === 2) {
        this.catalogueType = 1
        this.showType.jz = true
        this.showType.help = false
      }
      this.jzCatalogueList.forEach((item: any) => {
        if (item.id === id) {
          item.isActive = true
        } else {
          item.isActive = false
        }
      })
      this.helpCatalogueList.forEach((item: any) => {
        item.isActive = false
      })
    } else {
      if (this.catalogueType === 1) {
        this.catalogueType = 2
        this.showType.help = true
        this.showType.jz = false
      }
      this.helpCatalogueList.forEach((item: any) => {
        if (item.id === id) {
          item.isActive = true
        } else {
          item.isActive = false
        }
      })
      this.jzCatalogueList.forEach((item: any) => {
        item.isActive = false
      })
    }
  }
}
